/* ジムナビの横断検索。市区町村・駅・ジム名を1つの入力欄で、24時間ジム／パーソナル／ピラティスの地域記事と店舗レビューから探す。
   データ: /blogs/<blog>?view=gym-index（templates/blog.gym-index.liquid）と assets/gym-hub-reviews.json。初めて入力欄に触れたときに読む。
   使い方: <div data-gn-search data-reviews="{{ 'gym-hub-reviews.json' | asset_url }}" data-type="all|24h|personal|pilates">…</div>
   テスト: scripts/test/gn-search.test.cjs */
(function (root) {
  var PREFS = '北海道,青森県,岩手県,宮城県,秋田県,山形県,福島県,茨城県,栃木県,群馬県,埼玉県,千葉県,東京都,神奈川県,新潟県,富山県,石川県,福井県,山梨県,長野県,岐阜県,静岡県,愛知県,三重県,滋賀県,京都府,大阪府,兵庫県,奈良県,和歌山県,鳥取県,島根県,岡山県,広島県,山口県,徳島県,香川県,愛媛県,高知県,福岡県,佐賀県,長崎県,熊本県,大分県,宮崎県,鹿児島県,沖縄県'.split(',');
  var BLOGS = { 'gym-guide': '24h', 'personal-gym': 'personal', pilates: 'pilates' };
  var TYPE_LABEL = { '24h': '24時間ジム', personal: 'パーソナル', pilates: 'ピラティス', review: '店舗レビュー' };
  var TYPE_ORDER = { '24h': 0, personal: 1, pilates: 2, review: 3 };

  function norm(s) {
    return String(s || '').normalize('NFKC').toLowerCase().replace(/[\s　]+/g, '').replace(/[ヶヵケ]/g, 'ケ');
  }

  function areaEntry(a) {
    var type = BLOGS[a.blog];
    var tags = a.tags || [];
    if (!type || tags.indexOf('設備比較') >= 0) return null;
    var pref = tags.filter(function (t) { return PREFS.indexOf(t) >= 0; })[0] || '';
    var city = tags.filter(function (t) { return t !== pref && /[市区町村]$/.test(t); })[0] || '';
    var st = /^(?:.+?[都道府県])?(.+?駅)周辺/.exec(a.title || '');
    var label, level;
    if (tags.indexOf('駅周辺ガイド') >= 0 && st) { label = st[1] + '周辺'; level = 2; }
    else if (tags.indexOf('女性専用') >= 0 && !pref) { label = '女性専用（全国）'; level = 0; }
    else if (city) { label = pref + city; level = 1; }
    else if (pref) { label = pref; level = 0; }
    else return null;
    return { type: type, label: label, place: label.replace(pref, ''), sub: TYPE_LABEL[type], url: '/blogs/' + a.blog + '/' + a.handle, level: level,
      keys: norm(label + ' ' + (city || '') + ' ' + (tags.indexOf('女性専用') >= 0 ? '女性専用 女性' : '')) };
  }

  function buildIndex(data) {
    var out = [];
    var seen = {};
    (data.areas || []).forEach(function (a) {
      var e = areaEntry(a);
      if (!e) return;
      var k = e.type + '|' + e.label;
      if (seen[k]) return; // 同じ地域の古い記事は出さない（一覧は新しい順）
      seen[k] = 1; out.push(e);
    });
    (data.reviews || []).forEach(function (r) {
      out.push({ type: 'review', label: r.name, place: r.name, sub: (r.pref || '') + (r.city || '') + (r.stars != null ? '　★' + r.stars : ''),
        url: '/blogs/gym-review/' + r.handle, level: 3, keys: norm(r.name + ' ' + (r.pref || '') + (r.city || '')) });
    });
    return out;
  }

  function search(index, q, opt) {
    var nq = norm(q).replace(/(都|府|県)$/, '');
    if (!nq) return [];
    var type = opt && opt.type && opt.type !== 'all' ? opt.type : null;
    var limit = (opt && opt.limit) || 30;
    var hits = [];
    index.forEach(function (e) {
      if (type && e.type !== type) return;
      if (e.keys.indexOf(nq) < 0) return;
      // 一致の強さ: 地名ぴったり（「横浜」→横浜市）> 地名の頭（横浜市緑区）> 途中に含む。同じ強さなら県→市→駅→店、種類は24h→パーソナル→ピラティス
      var np = norm(e.place || e.label);
      var exact = np === nq || np === nq + '市' || np === nq + '区' || np === nq + '町' || np === nq + '村' || norm(e.label).replace(/(都|府|県)$/, '') === nq;
      var head = np.indexOf(nq) === 0 || norm(e.label).indexOf(nq) === 0;
      var score = (exact ? 0 : head ? 10 : 20) + e.level * 2 + TYPE_ORDER[e.type] * 0.1 + np.length * 0.001;
      hits.push({ e: e, s: score });
    });
    hits.sort(function (a, b) { return a.s - b.s; });
    return hits.slice(0, limit).map(function (h) { return { type: h.e.type, typeLabel: TYPE_LABEL[h.e.type], label: h.e.label, sub: h.e.sub, url: h.e.url }; });
  }

  var api = { buildIndex: buildIndex, search: search, norm: norm, TYPE_LABEL: TYPE_LABEL };
  if (typeof module === 'object' && module.exports) { module.exports = api; return; }
  if (root.GNSearch && root.GNSearch.mount) return; // 同じページで2回読み込まれても1回だけ動く
  root.GNSearch = api;

  // ---- ここから画面 ----
  var cache = {};
  function loadBlog(blog) {
    if (cache[blog]) return cache[blog];
    cache[blog] = (function next(page, acc) {
      return fetch('/blogs/' + blog + '?view=gym-index&page=' + page).then(function (r) { return r.ok ? r.json() : { articles: [], next: null }; })
        .then(function (d) {
          (d.articles || []).forEach(function (a) { a.blog = blog; acc.push(a); });
          return d.next ? next(d.next, acc) : acc;
        }).catch(function () { return acc; });
    })(1, []);
    return cache[blog];
  }
  var indexPromise = null;
  function getIndex(reviewsUrl) {
    if (!indexPromise) {
      indexPromise = Promise.all([loadBlog('gym-guide'), loadBlog('personal-gym'), loadBlog('pilates'),
        reviewsUrl ? fetch(reviewsUrl).then(function (r) { return r.json(); }).catch(function () { return []; }) : Promise.resolve([])])
        .then(function (r) { return buildIndex({ areas: r[0].concat(r[1], r[2]), reviews: Array.isArray(r[3]) ? r[3] : [] }); });
    }
    return indexPromise;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function mount(box) {
    if (box.__gn) return; box.__gn = 1;
    var input = box.querySelector('input');
    var list = box.querySelector('[data-gn-results]');
    var chips = box.querySelectorAll('[data-gn-type]');
    var type = box.getAttribute('data-type') || 'all';
    var reviews = box.getAttribute('data-reviews');
    var idx = null;
    function render() {
      var q = input.value;
      if (!norm(q)) { list.innerHTML = ''; list.hidden = true; return; }
      if (!idx) { list.hidden = false; list.innerHTML = '<p class="gn-s-empty">読み込み中…</p>'; return; }
      var r = search(idx, q, { type: type, limit: 20 });
      list.hidden = false;
      list.innerHTML = r.length ? r.map(function (x) {
        return '<a class="gn-s-item" href="' + esc(x.url) + '"><span class="gn-s-badge is-' + x.type + '">' + esc(x.typeLabel) + '</span>'
          + '<span class="gn-s-main"><span class="gn-s-label">' + esc(x.label) + '</span>' + (x.type === 'review' ? '<span class="gn-s-sub">' + esc(x.sub) + '</span>' : '') + '</span></a>';
      }).join('') : '<p class="gn-s-empty">見つかりませんでした。市区町村名（例：新宿、横浜）で探してみてください。</p>';
    }
    function warm() { getIndex(reviews).then(function (i) { idx = i; render(); }); }
    input.addEventListener('focus', warm, { once: true });
    input.addEventListener('input', function () { if (!idx) warm(); render(); });
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var first = list.querySelector('a.gn-s-item');
      if (first) { e.preventDefault(); location.href = first.href; }
    });
    Array.prototype.forEach.call(chips, function (c) {
      c.addEventListener('click', function () {
        type = c.getAttribute('data-gn-type');
        Array.prototype.forEach.call(chips, function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        render();
        if (!norm(input.value)) input.focus();
      });
    });
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-gn-search]'), mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  root.GNSearch.mount = mount;
})(this);
